import { mapGetters } from 'vuex'
import IntentText from './IntentText'
// import draggable from 'vuedraggable'
import IntentPrefill from './IntentPrefill'

import ModalDialog from '@/components/elements/ModalDialog'
import specialtext from '@/components/elements/specialtext'
import uploadfile from '@/components/elements/uploadfile'
import MoveVertical from '@/components/elements/MoveVertical'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea'
import AddGenericButton from '@/components/view/chatbot/AddGenericButton'
import IntentGenericManage from './IntentGenericManage'
import IntentNtnManage from './IntentNtnManage'
import IntentGetstarted from '@/components/view/intent/IntentGetstarted'
import MessageViewer from '@/components/elements/MessageViewer'
import ViewCartSummaryViewer from '@/components/elements/ViewCartSummaryViewer'
import ViewCartSummaryViewer2 from '@/components/elements/ViewCartSummaryViewer2'
import ChannelTab from '@/components/elements/ChannelTab'
import api from '@/api'
import ModalVideo from './ModalVideo'
import ModalMetaPay from './ModalMetaPay'
import IntentLineFlexMessage from './IntentLineFlexMessage'
import IntentLineImageMapMessage from './IntentLineImageMapMessage'
import IntentLineImageMap from './IntentLineImageMap'
import IntentLineFlex from './IntentLineFlex'
import IntentGbPrime from './IntentGbPrime'
import IntentCartAddRemove from './IntentCartAddRemove'
import StickerList from '@/components/elements/StickerList'
// import IntentVerifySlip from './IntentVerifySlip.vue'
// import IntentGbPrime from './IntentGbPrime'
import IntentPaySolution from './IntentPaySolution'
import dayjs from 'dayjs'
import config from '@/config'
import axios from 'axios'

export default {
  props: {
    isNotAltText: {
      default: false
    },
    isNotRatio: {
      default: false
    },
    value: {},
    intentname: {},
    isWelcome: {},
    indexAlternative: {},
    channel: {},
    isBroadCast: {},
    availableBubbles: {},
    isHasPrefill: { default: true },
    isBeacon: {
      dafault: false,
      type: Boolean
    },
    isIntent: {
      dafault: false,
      type: Boolean
    },
    followUp: {
      dafault: false,
      type: Boolean
    },
    messagesType: {
      default: ''
    },
    maxLength: {
      default: null
    },
    isIgType: {
      default: false,
      type: Boolean
    },
    groupType: {},
    customType: {},
    isLineShopping: {},
    isFirstAnnouncement: {
      default: false,
      type: Boolean
    },
    isZervaFollowup: {
      default: false,
      type: Boolean
    },
    isZervaAfterService: {
      default: false,
      type: Boolean
    },
    // isVerifySlip: {
    //   default: false,
    //   type: Boolean
    // },
    correct: {
      type: Array
    },
    incorrect: {
      type: Array
    },
    err: {
      type: Array
    },
    isRenderText: {
      type: Boolean,
      default: () => undefined
    },
  },
  inject: ['$validator'],
  data: function() {
    const vm = this
    return {
      countMenulist: 0,
      dialog: {
        addPayment: false,
        editPayment: false
      },
      showCartaddremoveTemp: '',
      gbprimeDialog: false,
      metaPayDialog: false,
      modalGbprime: null,
      valueMetaPay: null,
      bubbleMessages: vm.value,
      newButton: {
        title: '',
        type: 'web_url',
        url: ''
      },
      showVideo: false,
      showLineFlex: false,
      showLineImageMap: false,
      showLineSticker: false,
      flexMessage: undefined,
      imageMap: undefined,
      showCartaddremove: false,
      editTimestamp: dayjs().format('x'),
      saveTimestamp: dayjs().format('x'),
      welcome_channel: 'facebook',
      hasWCMultiChannel: false,
      remarkNtn: false,
      timestamp: dayjs().format('x'),
      currentTab: this.$route.query.tab,
      currentView: this.$route.name,
      paysolutionDialog: false,
      modalPaysolution: null,
    }
  },
  components: {
    IntentText,
    // draggable,
    IntentPrefill,
    IntentLineImageMapMessage,

    ModalDialog,
    specialtext,
    uploadfile,
    MoveVertical,
    AutoresizeTextarea,
    AddGenericButton,
    IntentGenericManage,
    IntentNtnManage,
    IntentGetstarted,
    MessageViewer,
    ViewCartSummaryViewer,
    ViewCartSummaryViewer2,
    ModalVideo,
    ModalMetaPay,
    IntentLineFlexMessage,
    IntentLineFlex,
    IntentGbPrime,
    IntentCartAddRemove,
    IntentLineImageMap,
    StickerList,
    ChannelTab,
    IntentPaySolution
    // IntentVerifySlip
    // Modal2
  },
  filters: {
    countByte(str) {
      var a = document.createElement('A')
      a.href = '#' + str
      var sEncoded = a.href
      sEncoded = sEncoded.substring(sEncoded.indexOf('#') + 1)
      var m = sEncoded.match(/%[0-9a-f]{2}/g)

      return sEncoded.length - (m ? m.length * 2 : 0)
    }
  },
  computed: {
    firstAnnouncementTool() {
      let vm = this
      return [
        {
          name: 'Message',
          type: 'text',
          activeBubble: 'text',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: { inactive: vm.bubbleCount >= vm.addLimit || vm.hasAloneIntent },
          imgFilePath: '/static/img/assets/get_started/add-speech-bubble.svg',
          isBroadCast: true,
          condition: true
        },
        {
          name: 'Button',
          type: 'button',
          activeBubble: 'button',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-button.svg',
          isBroadCast: true,
          condition: true
        },
        {
          name: 'Image',
          type: 'image',
          activeBubble: 'image',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-image.svg',
          isBroadCast: true,
          condition: true
        },
        {
          name: 'Menu list',
          type: 'generic',
          activeBubble: 'generic',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-menu_list.svg',
          isBroadCast: true,
          condition: true
        },
        {
          name: 'Video',
          type: 'video',
          activeBubble: 'video',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-video.svg',
          isBroadCast: true,
          condition: vm.currentTab != 'Comment'
        },
        {
          name: 'Line Flex',
          type: 'line_flex',
          activeBubble: 'line_flex',
          itemTooltip: {
            content: vm.hasAloneIntentTooltips,
            visible: vm.hasAloneIntent
          },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              !vm.getPackageType().includes('advanced') ||
              vm.isCoachlab ||
              vm.hasAloneIntent
          },
          imgFilePath: '/static/img/assets/get_started/add-menu_list.svg',
          isBroadCast: false,
          isAdvance: !vm.getPackageType().includes('advanced'),
          condition: vm.currentTab != 'Comment'
        },
        {
          name: 'Line Image Map',
          type: 'line_imagemap',
          activeBubble: 'line_imagemap',
          itemTooltip: {
            content: vm.hasAloneIntentTooltips,
            visible: vm.hasAloneIntent
          },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              !vm.getPackageType().includes('advanced') ||
              vm.hasAloneIntent
          },
          imgFilePath: '/static/img/assets/get_started/add-imagemap.svg',
          isBroadCast: false,
          isAdvance: !vm.getPackageType().includes('advanced'),
          condition: vm.currentTab != 'Comment'
        }
      ]
    },
    facebookTool() {
      const vm = this
      return [
        {
          name: 'Message',
          type: 'text',
          activeBubble: 'text',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: { inactive: vm.bubbleCount >= vm.addLimit || vm.hasAloneIntent },
          imgFilePath: '/static/img/assets/get_started/add-speech-bubble.svg',
          isBroadCast: false,
          condition: true
        },
        {
          name: 'Button',
          type: 'button',
          activeBubble: 'button',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-button.svg',
          isBroadCast: true,
          condition: true
        },
        {
          name: 'Image',
          type: 'image',
          activeBubble: 'image',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-image.svg',
          isBroadCast: true,
          condition: true
        },
        {
          name: 'Menu list',
          type: 'generic',
          activeBubble: 'generic',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-menu_list.svg',
          isBroadCast: true,
          condition: true
        },
        {
          name: 'product_catalogue',
          type: 'catalogue',
          activeBubble: 'generic',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/catalog-02.svg',
          isBroadCast: true,
          condition: true
        },
        {
          name: 'Meta Pay',
          type: 'meta',
          activeBubble: 'meta_pay',
          classItem: {
            inactive:
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast) ||
              vm.hasNtnIntent ||
              vm.channel === 'google'
          },
          imgFilePath: '/static/img/assets/get_started/add-payment.svg',
          isBroadCast: true,
          condition: !vm.isBroadCast
        },
        {
          name: 'Video',
          type: 'video',
          activeBubble: 'video',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-video.svg',
          isBroadCast: true,
          condition: vm.currentTab != 'Comment'
        },
        {
          name: 'Welcome',
          type: 'welcome_message',
          activeBubble: 'welcome_message',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit || vm.hasAloneIntent || vm.intentname == '{welcome}'
          },
          imgFilePath: '/static/img/assets/get_started/add-greeting.svg',
          isBroadCast: false,
          condition: vm.currentTab == 'Conversation'
        },
        {
          name: 'GB Prime Payment',
          type: 'gbPay',
          activeBubble: 'payment_form',
          itemTooltip: {
            content: vm.$t('GB Prime Payment function can be used only one alone.'),
            visible: vm.inactiveAloneIntent
          },
          classItem: {
            inactive:
              vm.inactiveAloneIntent || (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-payment.svg',
          isBroadCast: true,
          condition: vm.currentTab == 'Conversation'
        },
        {
          name: 'Pay Solutions',
          type: 'pay_solutions_link',
          activeBubble: 'pay_solutions_link',
          itemTooltip: {
            // content: vm.$t('GB Prime Payment function can be used only one alone.'),
            visible: vm.inactiveAloneIntent
          },
          classItem: {
            inactive:
              vm.inactiveAloneIntent || (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/paysolution/account_wallet.svg',
          isBroadCast: true,
          condition: vm.currentTab == 'Conversation'
        },
        {
          name: 'Add/Remove to cart',
          type: 'cart',
          activeBubble: 'add_cart',
          itemTooltip: {
            content: vm.$t('Add/Remove to cart function can be used only one alone.'),
            visible: vm.inactiveAloneIntent
          },
          classItem: {
            inactive:
              vm.inactiveAloneIntent || (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-cart.svg',
          isBroadCast: true,
          condition: !vm.isBroadCast
        },

        {
          name: 'Allow Marketing Messages',
          type: 'ntn_template',
          activeBubble: 'ntn_template',
          itemTooltip: {
            content: vm.hasAloneIntentTooltips,
            visible: vm.hasAloneIntent
          },
          classItem: {
            inactive: vm.bubbleCount >= vm.addLimit || vm.hasAloneIntent
          },
          imgFilePath: '/static/img/assets/get_started/add-speech-bubble.svg',
          condition: !vm.isWelcome
        }
      ]
    },
    sortFacebookTool() {
      const vm = this
      const m = vm.facebookTool
      m.sort((a, b) => {
        return b.classItem.inactive === a.classItem.inactive ? 0 : b.classItem.inactive ? -1 : 1
      })
      return m
    },
    lineTool() {
      const vm = this
      return [
        {
          name: 'Message',
          type: 'text',
          activeBubble: 'text',
          itemTooltip: { content: this.hasAloneIntentTooltips, visible: this.hasAloneIntent },
          classItem: { inactive: this.bubbleCount >= this.addLimit || this.hasAloneIntent },
          imgFilePath: '/static/img/assets/get_started/add-speech-bubble.svg',
          isBroadCast: false,
          condition: vm.currentTab != 'Comment'
        },
        {
          name: 'Button',
          type: 'button',
          activeBubble: 'button',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-button.svg',
          isBroadCast: true,
          condition: vm.currentTab != 'Comment'
        },
        {
          name: 'Image',
          type: 'image',
          activeBubble: 'image',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-image.svg',
          isBroadCast: true,
          condition: vm.currentTab != 'Comment'
        },
        {
          name: 'Menu list',
          type: 'generic',
          activeBubble: 'generic',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-menu_list.svg',
          isBroadCast: true,
          condition: vm.currentTab != 'Comment'
        },
        {
          name: 'product_catalogue',
          type: 'catalogue',
          activeBubble: 'generic',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/catalog-02.svg',
          isBroadCast: true,
          condition: vm.currentTab != 'Comment'
        },
        {
          name: 'Video',
          type: 'video',
          activeBubble: 'video',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-video.svg',
          isBroadCast: true,
          condition: vm.currentTab != 'Comment'
        },
        {
          name: 'Welcome',
          type: 'welcome_message',
          activeBubble: 'welcome_message',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit || vm.hasAloneIntent || vm.intentname == '{welcome}'
          },
          imgFilePath: '/static/img/assets/get_started/add-greeting.svg',
          isBroadCast: false,
          condition: vm.currentTab == 'Conversation'
        },
        {
          name: 'GB Prime Payment',
          type: 'gbPay',
          activeBubble: 'payment_form',
          itemTooltip: {
            content: vm.$t('GB Prime Payment function can be used only one alone.'),
            visible: vm.inactiveAloneIntent
          },
          classItem: {
            inactive:
              vm.inactiveAloneIntent || (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-payment.svg',
          isBroadCast: true,
          condition: vm.currentTab == 'Conversation'
        },
        {
          name: 'Pay Solutions',
          type: 'pay_solutions_link',
          activeBubble: 'pay_solutions_link',
          itemTooltip: {
            // content: vm.$t('GB Prime Payment function can be used only one alone.'),
            visible: vm.inactiveAloneIntent
          },
          classItem: {
            inactive:
              vm.inactiveAloneIntent || (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/paysolution/account_wallet.svg',
          isBroadCast: true,
          condition: vm.currentTab == 'Conversation'
        },
        {
          name: 'Add/Remove to cart',
          type: 'cart',
          activeBubble: 'add_cart',
          itemTooltip: {
            content: vm.$t('Add/Remove to cart function can be used only one alone.'),
            visible: vm.inactiveAloneIntent
          },
          classItem: {
            inactive:
              vm.inactiveAloneIntent || (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-cart.svg',
          isBroadCast: true,
          condition: vm.currentTab == 'Conversation'
        },
        {
          name: 'Line Flex',
          type: 'line_flex',
          activeBubble: 'line_flex',
          itemTooltip: {
            content: vm.hasAloneIntentTooltips,
            visible: vm.hasAloneIntent
          },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              !vm.getPackageType().includes('advanced') ||
              vm.isCoachlab ||
              vm.hasAloneIntent
          },
          imgFilePath: '/static/img/assets/get_started/add-menu_list.svg',
          isBroadCast: false,
          isAdvance: !vm.getPackageType().includes('advanced'),
          condition: vm.currentTab != 'Comment'
        },
        {
          name: 'Line Image Map',
          type: 'line_imagemap',
          activeBubble: 'line_imagemap',
          itemTooltip: {
            content: vm.hasAloneIntentTooltips,
            visible: vm.hasAloneIntent
          },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              !vm.getPackageType().includes('advanced') ||
              vm.hasAloneIntent
          },
          imgFilePath: '/static/img/assets/get_started/add-imagemap.svg',
          isBroadCast: false,
          isAdvance: !vm.getPackageType().includes('advanced'),
          condition: vm.currentTab != 'Comment'
        },
        {
          name: 'Line Sticker',
          type: 'line_sticker',
          activeBubble: 'line_sticker',
          itemTooltip: {
            content: vm.hasAloneIntentTooltips,
            visible: vm.hasAloneIntent
          },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              !vm.getPackageType().includes('advanced') ||
              vm.hasAloneIntent
          },
          imgFilePath: '/static/img/assets/get_started/add-line-sticker.svg',
          isBroadCast: false,
          isAdvance: !vm.getPackageType().includes('advanced'),
          condition: vm.currentTab != 'Comment'
        }
      ]
    },
    sortlineTool() {
      const vm = this
      const m = vm.lineTool
      m.sort((a, b) => {
        return b.classItem.inactive === a.classItem.inactive ? 0 : b.classItem.inactive ? -1 : 1
      })
      return m
    },
    igTool() {
      const vm = this
      return [
        {
          name: 'Message',
          type: 'text',
          activeBubble: 'text',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: { inactive: vm.bubbleCount >= vm.addLimit || vm.hasAloneIntent },
          imgFilePath: '/static/img/assets/get_started/add-speech-bubble.svg',
          isBroadCast: false,
          condition: true
        },
        {
          name: 'Button',
          type: 'button',
          activeBubble: 'button',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-button.svg',
          isBroadCast: true,
          condition: true
        },
        {
          name: 'Image',
          type: 'image',
          activeBubble: 'image',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-image.svg',
          isBroadCast: true,
          condition: true
        },
        {
          name: 'Menu list',
          type: 'generic',
          activeBubble: 'generic',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-menu_list.svg',
          isBroadCast: true,
          condition: true
        },
        {
          name: 'product_catalogue',
          type: 'catalogue',
          activeBubble: 'generic',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/catalog-02.svg',
          isBroadCast: true,
          condition: true
        },
        {
          name: 'Video',
          type: 'video',
          activeBubble: 'video',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-video.svg',
          isBroadCast: true,
          condition: vm.currentTab != 'Comment'
        },
        {
          name: 'Welcome',
          type: 'welcome_message',
          activeBubble: 'welcome_message',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit || vm.hasAloneIntent || vm.intentname == '{welcome}'
          },
          imgFilePath: '/static/img/assets/get_started/add-greeting.svg',
          isBroadCast: false,
          condition: vm.currentTab == 'Conversation'
        },
        {
          name: 'GB Prime Payment',
          type: 'gbPay',
          activeBubble: 'payment_form',
          itemTooltip: {
            content: vm.$t('GB Prime Payment function can be used only one alone.'),
            visible: vm.inactiveAloneIntent
          },
          classItem: {
            inactive:
              vm.inactiveAloneIntent || (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-payment.svg',
          isBroadCast: true,
          condition: vm.currentTab == 'Conversation'
        },
        {
          name: 'Pay Solutions',
          type: 'pay_solutions_link',
          activeBubble: 'pay_solutions_link',
          itemTooltip: {
            // content: vm.$t('GB Prime Payment function can be used only one alone.'),
            visible: vm.inactiveAloneIntent
          },
          classItem: {
            inactive:
              vm.inactiveAloneIntent || (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/paysolution/account_wallet.svg',
          isBroadCast: true,
          condition: vm.currentTab == 'Conversation'
        },
        {
          name: 'Add/Remove to cart',
          type: 'cart',
          activeBubble: 'add_cart',
          itemTooltip: {
            content: vm.$t('Add/Remove to cart function can be used only one alone.'),
            visible: vm.inactiveAloneIntent
          },
          classItem: {
            inactive:
              vm.inactiveAloneIntent || (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-cart.svg',
          isBroadCast: true,
          condition: !vm.isBroadCast
        },

        {
          name: 'Allow Marketing Messages',
          type: 'ntn_template',
          activeBubble: 'ntn_template',
          itemTooltip: {
            content: vm.hasAloneIntentTooltips,
            visible: vm.hasAloneIntent
          },
          classItem: {
            inactive: vm.bubbleCount >= vm.addLimit || vm.hasAloneIntent
          },
          imgFilePath: '/static/img/assets/get_started/add-speech-bubble.svg',
          condition: !vm.isWelcome
        }
      ]
    },
    sortIgTool() {
      const vm = this
      const m = vm.igTool
      m.sort((a, b) => {
        return b.classItem.inactive === a.classItem.inactive ? 0 : b.classItem.inactive ? -1 : 1
      })
      return m
    },
    googleTool() {
      const vm = this
      return [
        {
          name: 'Message',
          type: 'text',
          activeBubble: 'text',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: { inactive: vm.bubbleCount >= vm.addLimit || vm.hasAloneIntent },
          imgFilePath: '/static/img/assets/get_started/add-speech-bubble.svg',
          isBroadCast: false,
          condition: vm.currentTab != 'Comment'
        },
        {
          name: 'Button',
          type: 'button',
          activeBubble: 'button',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-button.svg',
          isBroadCast: true,
          condition: vm.currentTab != 'Comment'
        },
        {
          name: 'Image',
          type: 'image',
          activeBubble: 'image',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-image.svg',
          isBroadCast: true,
          condition: vm.currentTab != 'Comment'
        },
        {
          name: 'Menu list',
          type: 'generic',
          activeBubble: 'generic',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-menu_list.svg',
          isBroadCast: true,
          condition: vm.currentTab != 'Comment'
        },
        {
          name: 'product_catalogue',
          type: 'catalogue',
          activeBubble: 'generic',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/catalog-02.svg',
          isBroadCast: true,
          condition: vm.currentTab != 'Comment'
        },
        {
          name: 'Welcome',
          type: 'welcome_message',
          activeBubble: 'welcome_message',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit || vm.hasAloneIntent || vm.intentname == '{welcome}'
          },
          imgFilePath: '/static/img/assets/get_started/add-greeting.svg',
          isBroadCast: false,
          condition: vm.currentTab == 'Conversation'
        },
        {
          name: 'GB Prime Payment',
          type: 'gbPay',
          activeBubble: 'payment_form',
          itemTooltip: {
            content: vm.$t('GB Prime Payment function can be used only one alone.'),
            visible: vm.inactiveAloneIntent
          },
          classItem: {
            inactive:
              vm.inactiveAloneIntent || (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-payment.svg',
          isBroadCast: true,
          condition: vm.currentTab == 'Conversation'
        },
        {
          name: 'Pay Solutions',
          type: 'pay_solutions_link',
          activeBubble: 'pay_solutions_link',
          itemTooltip: {
            // content: vm.$t('GB Prime Payment function can be used only one alone.'),
            visible: vm.inactiveAloneIntent
          },
          classItem: {
            inactive:
              vm.inactiveAloneIntent || (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/paysolution/account_wallet.svg',
          isBroadCast: true,
          condition: vm.currentTab == 'Conversation'
        },
        {
          name: 'Add/Remove to cart',
          type: 'cart',
          activeBubble: 'add_cart',
          itemTooltip: {
            content: vm.$t('Add/Remove to cart function can be used only one alone.'),
            visible: vm.inactiveAloneIntent
          },
          classItem: {
            inactive:
              vm.inactiveAloneIntent || (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-cart.svg',
          isBroadCast: true,
          condition: vm.currentTab == 'Conversation'
        }
      ]
    },
    sortGoogleTool() {
      const vm = this
      const m = vm.googleTool
      m.sort((a, b) => {
        return b.classItem.inactive === a.classItem.inactive ? 0 : b.classItem.inactive ? -1 : 1
      })
      return m
    },
    whatsApp() {
      const vm = this
      return [
        {
          name: 'Message',
          type: 'text',
          activeBubble: 'text',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: { inactive: vm.bubbleCount >= vm.addLimit || vm.hasAloneIntent },
          imgFilePath: '/static/img/assets/get_started/add-speech-bubble.svg',
          isBroadCast: false,
          condition: vm.currentTab != 'Comment'
        },
        {
          name: 'Button',
          type: 'button',
          activeBubble: 'button',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-button.svg',
          isBroadCast: true,
          condition: vm.currentTab != 'Comment'
        },
        {
          name: 'Image',
          type: 'image',
          activeBubble: 'image',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-image.svg',
          isBroadCast: true,
          condition: vm.currentTab != 'Comment'
        },
        {
          name: 'Menu list',
          type: 'generic',
          activeBubble: 'generic',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-menu_list.svg',
          isBroadCast: true,
          condition: vm.currentTab != 'Comment'
        },
        {
          name: 'Video',
          type: 'video',
          activeBubble: 'video',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-video.svg',
          isBroadCast: true,
          condition: vm.currentTab != 'Comment'
        }
      ]
    },
    sortWhatsApp() {
      const vm = this
      const m = vm.whatsApp
      m.sort((a, b) => {
        return b.classItem.inactive === a.classItem.inactive ? 0 : b.classItem.inactive ? -1 : 1
      })
      return m
    },
    messageTool() {
      const vm = this
      const packages = this.selectedBot.packages
      return [
        {
          name: 'Message',
          type: 'text',
          activeBubble: 'text',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: { inactive: vm.bubbleCount >= vm.addLimit || vm.hasAloneIntent },
          imgFilePath: '/static/img/assets/get_started/add-speech-bubble.svg',
          isBroadCast: false,
          condition: true
        },
        {
          name: 'Button',
          type: 'button',
          activeBubble: 'button',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-button.svg',
          isBroadCast: true,
          condition: true
        },
        {
          name: 'Image',
          type: 'image',
          activeBubble: 'image',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-image.svg',
          isBroadCast: true,
          condition: true
        },
        {
          name: 'Menu list',
          type: 'generic',
          activeBubble: 'generic',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-menu_list.svg',
          isBroadCast: true,
          condition: true
        },
        {
          name: 'product_catalogue',
          type: 'catalogue',
          activeBubble: 'generic',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/catalog-02.svg',
          isBroadCast: true,
          condition: true
        },
        {
          name: 'Meta Pay',
          type: 'meta',
          activeBubble: 'meta_pay',
          classItem: {
            inactive:
              vm.inactiveAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast) ||
              vm.hasNtnIntent
          },
          imgFilePath: '/static/img/assets/get_started/add-payment.svg',
          isBroadCast: true,
          condition: packages.includes('facebook')
        },
        {
          name: 'Video',
          type: 'video',
          activeBubble: 'video',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast) ||
              (packages.length <= 1 && packages.includes('google'))
          },
          imgFilePath: '/static/img/assets/get_started/add-video.svg',
          isBroadCast: true,
          condition: true
        },
        {
          name: 'Welcome',
          type: 'welcome_message',
          activeBubble: 'welcome_message',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit || vm.hasAloneIntent || vm.intentname == '{welcome}'
          },
          imgFilePath: '/static/img/assets/get_started/add-greeting.svg',
          isBroadCast: false,
          condition: vm.currentTab == 'Conversation'
        },
        {
          name: 'GB Prime Payment',
          type: 'gbPay',
          activeBubble: 'payment_form',
          itemTooltip: {
            content: vm.$t('GB Prime Payment function can be used only one alone.'),
            visible: vm.inactiveAloneIntent
          },
          classItem: {
            inactive:
              vm.inactiveAloneIntent || (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-payment.svg',
          isBroadCast: true,
          condition: vm.currentTab == 'Conversation'
        },
        {
          name: 'Pay Solutions',
          type: 'pay_solutions_link',
          activeBubble: 'pay_solutions_link',
          itemTooltip: {
            // content: vm.$t('GB Prime Payment function can be used only one alone.'),
            visible: vm.inactiveAloneIntent
          },
          classItem: {
            inactive:
              vm.inactiveAloneIntent || (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/paysolution/account_wallet.svg',
          isBroadCast: true,
          condition: vm.currentTab == 'Conversation'
        },
        {
          name: 'Add/Remove to cart',
          type: 'cart',
          activeBubble: 'add_cart',
          itemTooltip: {
            content: vm.$t('Add/Remove to cart function can be used only one alone.'),
            visible: vm.inactiveAloneIntent
          },
          classItem: {
            inactive:
              vm.inactiveAloneIntent || (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-cart.svg',
          isBroadCast: true,
          condition: !vm.isBroadCast
        },
        {
          name: 'Line Flex',
          type: 'line_flex',
          activeBubble: 'line_flex',
          itemTooltip: {
            content: vm.hasAloneIntentTooltips,
            visible: vm.hasAloneIntent
          },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              !vm.getPackageType().includes('advanced') ||
              vm.isCoachlab ||
              vm.hasAloneIntent
          },
          imgFilePath: '/static/img/assets/get_started/add-menu_list.svg',
          isBroadCast: false,
          isAdvance: !vm.getPackageType().includes('advanced'),
          condition: packages.includes('line') && vm.currentTab != 'Comment'
        },
        {
          name: 'Line Image Map',
          type: 'line_imagemap',
          activeBubble: 'line_imagemap',
          itemTooltip: {
            content: vm.hasAloneIntentTooltips,
            visible: vm.hasAloneIntent
          },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              !vm.getPackageType().includes('advanced') ||
              vm.hasAloneIntent
          },
          imgFilePath: '/static/img/assets/get_started/add-imagemap.svg',
          isBroadCast: false,
          isAdvance: !vm.getPackageType().includes('advanced'),
          condition: packages.includes('line') && vm.currentTab != 'Comment'
        },
        {
          name: 'Line Sticker',
          type: 'line_sticker',
          activeBubble: 'line_sticker',
          itemTooltip: {
            content: vm.hasAloneIntentTooltips,
            visible: vm.hasAloneIntent
          },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              !vm.getPackageType().includes('advanced') ||
              vm.hasAloneIntent
          },
          imgFilePath: '/static/img/assets/get_started/add-line-sticker.svg',
          isBroadCast: false,
          isAdvance: !vm.getPackageType().includes('advanced'),
          condition: packages.includes('line') && vm.currentTab != 'Comment'
        },
        {
          name: 'Allow Marketing Messages',
          type: 'ntn_template',
          activeBubble: 'ntn_template',
          itemTooltip: {
            content: vm.hasAloneIntentTooltips,
            visible: vm.hasAloneIntent
          },
          classItem: {
            inactive: vm.bubbleCount >= vm.addLimit || vm.hasAloneIntent
          },
          imgFilePath: '/static/img/assets/get_started/add-speech-bubble.svg',
          condition: packages.includes('facebook') || packages.includes('instagram')
        }
      ]
    },
    sortMessageTool() {
      const vm = this
      let m = vm.messageTool
      m.sort((a, b) => {
        return b.classItem.inactive === a.classItem.inactive ? 0 : b.classItem.inactive ? -1 : 1
      })
      if (vm.isBeacon) {
        m = m.filter(item => {
          if (item.type !== 'ntn_template' && item.type !== 'meta') {
            return item
          }
        })
      }
      return m
    },
    broadcastTool() {
      const vm = this
      let groupType = vm.groupType
      let customType = vm.customType

      if (groupType != 'customize') {
        return [
          {
            name: 'Message',
            type: 'text',
            activeBubble: 'text',
            itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
            classItem: { inactive: vm.bubbleCount >= vm.addLimit || vm.hasAloneIntent },
            imgFilePath: '/static/img/assets/get_started/add-speech-bubble.svg',
            isBroadCast: true,
            condition: true
          },
          {
            name: 'Button',
            type: 'button',
            activeBubble: 'button',
            itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
            classItem: {
              inactive:
                vm.bubbleCount >= vm.addLimit ||
                vm.hasAloneIntent ||
                (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
            },
            imgFilePath: '/static/img/assets/get_started/add-button.svg',
            isBroadCast: true,
            condition: true
          },
          {
            name: 'Image',
            type: 'image',
            activeBubble: 'image',
            itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
            classItem: {
              inactive:
                vm.bubbleCount >= vm.addLimit ||
                vm.hasAloneIntent ||
                (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
            },
            imgFilePath: '/static/img/assets/get_started/add-image.svg',
            isBroadCast: true,
            condition: true
          },
          {
            name: 'Menu list',
            type: 'generic',
            activeBubble: 'generic',
            itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
            classItem: {
              inactive:
                vm.bubbleCount >= vm.addLimit ||
                vm.hasAloneIntent ||
                (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
            },
            imgFilePath: '/static/img/assets/get_started/add-menu_list.svg',
            isBroadCast: true,
            condition: true
          },
          {
            name: 'product_catalogue',
            type: 'catalogue',
            activeBubble: 'generic',
            itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
            classItem: {
              inactive:
                vm.bubbleCount >= vm.addLimit ||
                vm.hasAloneIntent ||
                (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
            },
            imgFilePath: '/static/img/assets/get_started/catalog-02.svg',
            isBroadCast: true,
            condition: true
          },
          {
            name: 'Meta Pay',
            type: 'meta',
            activeBubble: 'meta_pay',
            classItem: {
              inactive:
                vm.inactiveAloneIntent ||
                (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast) ||
                vm.hasNtnIntent
            },
            imgFilePath: '/static/img/assets/get_started/add-payment.svg',
            isBroadCast: true,
            condition:
              vm.groupType == 'facebook' ||
              (vm.groupType == 'customize' && vm.customType == 'facebook')
          },
          {
            name: 'Video',
            type: 'video',
            activeBubble: 'video',
            itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
            classItem: {
              inactive:
                vm.bubbleCount >= vm.addLimit ||
                vm.hasAloneIntent ||
                vm.$store.getters.getPackage == 'normal'
            },
            imgFilePath: '/static/img/assets/get_started/add-video.svg',
            isBroadCast: true,
            condition:
              vm.groupType != 'google' || (vm.groupType == 'customize' && vm.customType != 'google')
          },
          {
            name: 'Line Flex',
            type: 'line_flex',
            activeBubble: 'line_flex',
            itemTooltip: {
              content: vm.hasAloneIntentTooltips,
              visible: vm.hasAloneIntent
            },
            classItem: {
              inactive:
                vm.bubbleCount >= vm.addLimit ||
                !vm.getPackageType().includes('advanced') ||
                vm.isCoachlab ||
                vm.hasAloneIntent
            },
            imgFilePath: '/static/img/assets/get_started/add-menu_list.svg',
            isBroadCast: true,
            isAdvance: !vm.getPackageType().includes('advanced'),
            condition:
              groupType == 'line' ||
              (groupType == 'customize' && customType != 'line') ||
              groupType == 'line-group' ||
              (groupType == 'customize' && customType != 'line-group')
          },
          {
            name: 'Line Image Map',
            type: 'line_imagemap',
            activeBubble: 'line_imagemap',
            itemTooltip: {
              content: vm.hasAloneIntentTooltips,
              visible: vm.hasAloneIntent
            },
            classItem: {
              inactive:
                vm.bubbleCount >= vm.addLimit ||
                !vm.getPackageType().includes('advanced') ||
                vm.hasAloneIntent
            },
            imgFilePath: '/static/img/assets/get_started/add-imagemap.svg',
            isBroadCast: true,
            isAdvance: !vm.getPackageType().includes('advanced'),
            condition:
              groupType == 'line' ||
              (groupType == 'customize' && customType != 'line') ||
              groupType == 'line-group' ||
              (groupType == 'customize' && customType != 'line-group')
          },
          {
            name: 'Line Sticker',
            type: 'line_sticker',
            activeBubble: 'line_sticker',
            itemTooltip: {
              content: vm.hasAloneIntentTooltips,
              visible: vm.hasAloneIntent
            },
            classItem: {
              inactive:
                vm.bubbleCount >= vm.addLimit ||
                !vm.getPackageType().includes('advanced') ||
                vm.hasAloneIntent
            },
            imgFilePath: '/static/img/assets/get_started/add-line-sticker.svg',
            isBroadCast: true,
            isAdvance: !vm.getPackageType().includes('advanced'),
            condition:
              groupType == 'line' ||
              (groupType == 'customize' && customType != 'line') ||
              groupType == 'line-group' ||
              (groupType == 'customize' && customType != 'line-group')
          },
          {
            name: 'Allow Marketing Messages',
            type: 'ntn_template',
            activeBubble: 'ntn_template',
            itemTooltip: {
              content: vm.hasAloneIntentTooltips,
              visible: vm.hasAloneIntent
            },
            classItem: {
              inactive: vm.bubbleCount >= vm.addLimit || vm.hasAloneIntent
            },
            imgFilePath: '/static/img/assets/get_started/add-speech-bubble.svg',
            condition:
              (vm.messagesType != 'NTN_BROADCAST' && groupType == 'facebook') ||
              (groupType == 'customize' && customType != 'facebook') ||
              groupType == 'instagram' ||
              (groupType == 'customize' && customType != 'instagram')
          }
        ]
      } else {
        return [
          {
            name: 'Message',
            type: 'text',
            activeBubble: 'text',
            itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
            classItem: { inactive: vm.bubbleCount >= vm.addLimit || vm.hasAloneIntent },
            imgFilePath: '/static/img/assets/get_started/add-speech-bubble.svg',
            isBroadCast: true,
            condition: true
          },
          {
            name: 'Button',
            type: 'button',
            activeBubble: 'button',
            itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
            classItem: {
              inactive:
                vm.bubbleCount >= vm.addLimit ||
                vm.hasAloneIntent ||
                (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
            },
            imgFilePath: '/static/img/assets/get_started/add-button.svg',
            isBroadCast: true,
            condition: true
          },
          {
            name: 'Image',
            type: 'image',
            activeBubble: 'image',
            itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
            classItem: {
              inactive:
                vm.bubbleCount >= vm.addLimit ||
                vm.hasAloneIntent ||
                (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
            },
            imgFilePath: '/static/img/assets/get_started/add-image.svg',
            isBroadCast: true,
            condition: true
          },
          {
            name: 'Menu list',
            type: 'generic',
            activeBubble: 'generic',
            itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
            classItem: {
              inactive:
                vm.bubbleCount >= vm.addLimit ||
                vm.hasAloneIntent ||
                (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
            },
            imgFilePath: '/static/img/assets/get_started/add-menu_list.svg',
            isBroadCast: true,
            condition: true
          },
          {
            name: 'product_catalogue',
            type: 'catalogue',
            activeBubble: 'generic',
            itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
            classItem: {
              inactive:
                vm.bubbleCount >= vm.addLimit ||
                vm.hasAloneIntent ||
                (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
            },
            imgFilePath: '/static/img/assets/get_started/catalog-02.svg',
            isBroadCast: true,
            condition: true
          },
          {
            name: 'Meta Pay',
            type: 'meta',
            activeBubble: 'meta_pay',
            classItem: {
              inactive:
                vm.inactiveAloneIntent ||
                (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast) ||
                vm.hasNtnIntent
            },
            imgFilePath: '/static/img/assets/get_started/add-payment.svg',
            isBroadCast: true,
            condition: customType == 'facebook'
          },
          {
            name: 'Video',
            type: 'video',
            activeBubble: 'video',
            itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
            classItem: {
              inactive:
                vm.bubbleCount >= vm.addLimit ||
                vm.hasAloneIntent ||
                vm.$store.getters.getPackage == 'normal'
            },
            imgFilePath: '/static/img/assets/get_started/add-video.svg',
            isBroadCast: true,
            condition: customType != 'google'
          },
          {
            name: 'Line Flex',
            type: 'line_flex',
            activeBubble: 'line_flex',
            itemTooltip: {
              content: vm.hasAloneIntentTooltips,
              visible: vm.hasAloneIntent
            },
            classItem: {
              inactive:
                vm.bubbleCount >= vm.addLimit ||
                !vm.getPackageType().includes('advanced') ||
                vm.isCoachlab ||
                vm.hasAloneIntent
            },
            imgFilePath: '/static/img/assets/get_started/add-menu_list.svg',
            isBroadCast: true,
            isAdvance: !vm.getPackageType().includes('advanced'),
            condition: customType == 'line' || customType == 'line-group'
          },
          {
            name: 'Line Image Map',
            type: 'line_imagemap',
            activeBubble: 'line_imagemap',
            itemTooltip: {
              content: vm.hasAloneIntentTooltips,
              visible: vm.hasAloneIntent
            },
            classItem: {
              inactive:
                vm.bubbleCount >= vm.addLimit ||
                !vm.getPackageType().includes('advanced') ||
                vm.hasAloneIntent
            },
            imgFilePath: '/static/img/assets/get_started/add-imagemap.svg',
            isBroadCast: true,
            isAdvance: !vm.getPackageType().includes('advanced'),
            condition: customType == 'line' || customType == 'line-group'
          },
          {
            name: 'Line Sticker',
            type: 'line_sticker',
            activeBubble: 'line_sticker',
            itemTooltip: {
              content: vm.hasAloneIntentTooltips,
              visible: vm.hasAloneIntent
            },
            classItem: {
              inactive:
                vm.bubbleCount >= vm.addLimit ||
                !vm.getPackageType().includes('advanced') ||
                vm.hasAloneIntent
            },
            imgFilePath: '/static/img/assets/get_started/add-line-sticker.svg',
            isBroadCast: true,
            isAdvance: !vm.getPackageType().includes('advanced'),
            condition: customType == 'line' || customType == 'line-group'
          },
          {
            name: 'Allow Marketing Messages',
            type: 'ntn_template',
            activeBubble: 'ntn_template',
            itemTooltip: {
              content: vm.hasAloneIntentTooltips,
              visible: vm.hasAloneIntent
            },
            classItem: {
              inactive: vm.bubbleCount >= vm.addLimit || vm.hasAloneIntent
            },
            imgFilePath: '/static/img/assets/get_started/add-speech-bubble.svg',
            condition: customType == 'facebook' || customType == 'instagram'
          }
        ]
      }
    },
    sortBroadcastTool() {
      const vm = this
      const m = vm.broadcastTool
      m.sort((a, b) => {
        return b.classItem.inactive === a.classItem.inactive ? 0 : b.classItem.inactive ? -1 : 1
      })
      return m
    },
    activeBubbles() {
      const vm = this
      if (vm.availableBubbles) return vm.availableBubbles
      else return vm.$store.state.defaultBubbleList
    },
    hasNtnIntent() {
      const vm = this
      return vm.value.some(el => {
        return ['meta_pay'].includes(el.type)
      })
    },
    hasAloneIntent() {
      const vm = this
      return vm.value.some(el => {
        return ['removeandaddtocart', 'addtocart', 'removetocart', 'payment', 'pay_solutions_link'].includes(el.type)
      })
    },
    inactiveAloneIntent() {
      const vm = this
      return vm.bubbleCount >= vm.addLimit || vm.bubbleCount > 0
    },
    hasAloneIntentTooltips() {
      const vm = this
      if (
        vm.value.some(el => {
          return ['removeandaddtocart', 'addtocart', 'removetocart'].includes(el.type)
        })
      ) {
        return vm.$t('Choosing Add/Remove to cart function, the item can be used only one alone.')
      } else if (vm.value.some(el => ['pay_solutions_link'].includes(el.type))) {
        return vm.$t('Choosing Pay Solution Payment function, the item can be used only one alone.')
      } else {
        return vm.$t('Choosing GB Prime Payment function, the item can be used only one alone.')
      }
    },
    followUpTool() {
      const vm = this
      return [
        {
          name: 'Summary of Service Received',
          type: 'summary_service',
          activeBubble: 'text',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: { inactive: vm.bubbleCount >= vm.addLimit || vm.hasAloneIntent },
          imgFilePath: '/static/img/assets/get_started/income_summary.svg',
          isBroadCast: false,
          condition: !!vm.isZervaAfterService
        },
        {
          name: 'Message',
          type: 'text',
          activeBubble: 'text',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: { inactive: vm.bubbleCount >= vm.addLimit || vm.hasAloneIntent },
          imgFilePath: '/static/img/assets/get_started/add-speech-bubble.svg',
          isBroadCast: false,
          condition: true
        },
        {
          name: 'Button',
          type: 'button',
          activeBubble: 'button',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-button.svg',
          isBroadCast: true,
          condition: true
        },
        {
          name: 'Image',
          type: 'image',
          activeBubble: 'image',
          itemTooltip: { content: vm.hasAloneIntentTooltips, visible: vm.hasAloneIntent },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              vm.hasAloneIntent ||
              (vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
          },
          imgFilePath: '/static/img/assets/get_started/add-image.svg',
          isBroadCast: true,
          condition: true
        },
        {
          name: 'Line Flex',
          type: 'line_flex',
          activeBubble: 'line_flex',
          itemTooltip: {
            content: vm.hasAloneIntentTooltips,
            visible: vm.hasAloneIntent
          },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              !vm.getPackageType().includes('advanced') ||
              vm.isCoachlab ||
              vm.hasAloneIntent
          },
          imgFilePath: '/static/img/assets/get_started/add-menu_list.svg',
          isBroadCast: false,
          isAdvance: !vm.getPackageType().includes('advanced'),
          condition: vm.channel === 'line'
        },
        {
          name: 'Line Image Map',
          type: 'line_imagemap',
          activeBubble: 'line_imagemap',
          itemTooltip: {
            content: vm.hasAloneIntentTooltips,
            visible: vm.hasAloneIntent
          },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              !vm.getPackageType().includes('advanced') ||
              vm.hasAloneIntent
          },
          imgFilePath: '/static/img/assets/get_started/add-imagemap.svg',
          isBroadCast: false,
          isAdvance: !vm.getPackageType().includes('advanced'),
          condition: vm.channel === 'line'
        },
        {
          name: 'Line Sticker',
          type: 'line_sticker',
          activeBubble: 'line_sticker',
          itemTooltip: {
            content: vm.hasAloneIntentTooltips,
            visible: vm.hasAloneIntent
          },
          classItem: {
            inactive:
              vm.bubbleCount >= vm.addLimit ||
              !vm.getPackageType().includes('advanced') ||
              vm.hasAloneIntent
          },
          imgFilePath: '/static/img/assets/get_started/add-line-sticker.svg',
          isBroadCast: false,
          isAdvance: !vm.getPackageType().includes('advanced'),
          condition: vm.channel === 'line'
        }
      ]
    },
    sortFollowUpTool() {
      const vm = this
      const m = vm.followUpTool
      m.sort((a, b) => {
        return b.classItem.inactive === a.classItem.inactive ? 0 : b.classItem.inactive ? -1 : 1
      })
      return m
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      products: 'getProducts',
      isCoachlab: 'isCoachlab'
    }),
    welcomeMessage() {
      let { messages, multichannel } = this.$store.getters.welcomeMessage2(
        this.channel == 'all' ? this.welcome_channel : this.channel
      )
      this.hasWCMultiChannel = multichannel
      return messages
    },
    channelItem() {
      let isZervaIntent = false

      if (this.intent) {
        isZervaIntent = this.intent.a_val.includes('{zerva_url}')
      }

      const packages = this.selectedBot.packages
      let channels = [
        {
          name: 'facebook',
          icon: 'fa-facebook',
          color: '#3c5a99',
          tab: 'facebook'
        },
        {
          name: 'instagram',
          icon: 'fa-instagram',
          color: '#d6249f',
          tab: 'instagram'
        },
        {
          name: 'whatsapp',
          icon: 'fa-whatsapp',
          color: '#06b901',
          tab: 'whatsapp'
        },
        {
          name: 'line',
          icon: 'fa-line',
          color: '#06b901',
          tab: 'line'
        },
        {
          name: 'google',
          icon: 'fa-google',
          color: '#F4B400',
          tab: 'google'
        }
      ]

      channels = channels.filter(el => packages.includes(el.name))

      if (isZervaIntent) {
        channels = channels.filter(el => ['facebook', 'line'].includes(el.name))
      }

      return channels
    },
    commentChannelitem() {
      const packages = this.selectedBot.packages
      let channels = [
        {
          name: 'facebook',
          icon: 'fa-facebook',
          color: '#3c5a99',
          tab: 'facebook'
        },
        {
          name: 'instagram',
          icon: 'fa-instagram',
          color: '#d6249f',
          tab: 'instagram'
        }
      ]
      channels = channels.filter(el => packages.includes(el.name))
      return channels
    },
    bubbleCount: function() {
      var vm = this
      if (vm.bubbleMessages) {
        var count = 0
        vm.countMenulist = 0
        vm.bubbleMessages.map(bubble => {
          if (bubble.type == 'generic') {
            vm.countMenulist++
          }
          if (bubble.type == 'welcome_message') {
            if (vm.welcomeMessage && vm.welcomeMessage.messages && vm.welcomeMessage.messages[0]) {
              count += vm.welcomeMessage.messages[0].length
            } else {
              count++
            }
          } else {
            count++
          }
        })
        return count
      } else {
        return 0
      }
    },
    addLimit() {
      const vm = this
      let isBeacon = vm.isBeacon
      let isLineShopping = vm.isLineShopping
      let messagesType = vm.messagesType
      let isFirstAnnouncement = vm.isFirstAnnouncement
      let isZervaFollowup = vm.isZervaFollowup
      if (isZervaFollowup) {
        return 5
      } else if (isFirstAnnouncement) {
        return 3
      } else if (isBeacon || isLineShopping) {
        return 5
      } else if (messagesType === 'NTN_BROADCAST') {
        return 1
      } else {
        if (vm.maxLength && typeof vm.maxLength === 'number') {
          return vm.maxLength
        } else {
          return vm.getPackageConfig().bubbles
        }
      }
    },
    correctMsg: {
      get() {
        return this.correct
      },
      set(value) {
        this.$emit('update:correct', value)
      }
    },
    incorrectMsg: {
      get() {
        return this.incorrect
      },
      set(value) {
        this.$emit('update:incorrect', value)
      }
    },
    errMsg: {
      get() {
        return this.err
      },
      set(value) {
        this.$emit('update:err', value)
      }
    }
  },
  mounted: function() {
    const vm = this
    this.resetFlexMessage()
  },
  methods: {
    async checkBotTest(button) {
      let data = {
        params: { pageid: this.selectedBot.pageid },
        body: {
          app: 'facebook',
          context: '',
          message: button.payload
        }
      }
      let response = await axios.post(config.serverUrl + 'test_webchat', data.body, {
        params: data.params
      })
      if (response && response.data && response.data.data) {
        return response.data.data
      }
    },
    changeWelcomeChannelTab(val) {
      this.welcome_channel = val
    },
    addSticker({ packageid, stickerid }) {
      this.bubbleMessages.push({
        packageid: packageid,
        stickerid: stickerid,
        type: 'sticker'
      })
    },
    changealtText(index, payload) {
      this.$set(this.bubbleMessages[index], 'altText', payload)
    },
    changeRatio(index, payload) {
      this.$set(
        this.bubbleMessages[index],
        'ratio',
        payload == 'horizontal' ? 'horizontal' : 'square'
      )
    },
    cancelAddImageMap() {
      this.showLineImageMap = false
      this.resetImageMap()
    },
    saveAddImageMap() {
      var vm = this
      var imagemap = null

      try {
        imagemap = JSON.parse(vm.imageMap)
        vm.bubbleMessages.push({
          ...imagemap,
          type: 'imagemap'
        })
        vm.$emit('input', vm.bubbleMessages)
      } catch (error) {}
      vm.showLineImageMap = false
      vm.resetImageMap()
    },
    resetImageMap() {
      this.imageMap = '{}'
    },
    closecartaddremove() {
      this.showCartaddremove = false
    },
    cartaddremove() {
      var vm = this
      if (
        vm.bubbleCount < vm.addLimit &&
        vm.bubbleCount <= 0 &&
        this.$store.getters.getPackage !== 'normal' &&
        !this.isBroadCast
      ) {
        this.showCartaddremoveTemp = ''
        this.showCartaddremove = true
      }
    },
    editRemoveAndAdd(item, index) {
      this.showCartaddremoveTemp = {
        input: [...item.data],
        type: item.type,
        index,
        checksameproductincarts: item.checksameproductincarts,
        checkstock: item.checkstock,
        adjuststock: item.adjuststock
      }

      this.showCartaddremove = true
    },
    updateRemoveAndAdd(obj) {
      var vm = this
      var mytext = obj.data.map(el => `{"pid":${el.pid},"qty":${el.qty},"option":"${el.option}"}`)
      Object.assign(this.bubbleMessages[obj.index], {
        data: obj.data,
        text: `{${obj.type}([${mytext}])}`,
        type: obj.type,
        checkstock: obj.checkstock,
        checksameproductincarts: obj.checksameproductincarts,
        adjuststock: obj.adjuststock
      })
    },
    metaPayForm(item, index) {
      const vm = this
      console.log(this.$store.getters.getPackage)
      if (
        (vm.bubbleCount < vm.addLimit && !vm.hasNtnIntent && !['google'].includes(vm.channel)) ||
        typeof index !== 'undefined'
      ) {
        if (this.$store.getters.getPackage != 'normal' && !this.isBroadCast) {
          let input = {
            type: 'meta_pay',
            detail: '',
            amount: '',
            note: '',
            is_create_order: false,
            create: true
          }
          vm.metaPayDialog = true
          vm.valueMetaPay = item && item.amount ? { ...item, index, create: false } : input
        }
      }
    },
    paymentForm(item, index) {
      var vm = this
      if ((vm.bubbleCount < vm.addLimit && vm.bubbleCount <= 0) || index || index === 0) {
        if (!(this.$store.getters.getPackage == 'normal' && this.isBroadCast)) {
          let input = {
            detail: '',
            amount: 0,
            delivery: { name: '', code: 0 },
            response: 'จ่ายบิลได้ที่',
            type: 'payprime',
            create: true
          }
          vm.gbprimeDialog = true
          vm.modalGbprime = item && item.text ? { ...item.data, index, create: false } : input
          // this.$store.commit('modalAssign', {
          //   component: IntentGbPrime,
          //   input: item.text ? { ...item.data, index, create: false } : input,
          //   open: true
          // })
        }
      }
    },
    paysolutionForm(item, index) {
      var vm = this
      if ((vm.bubbleCount < vm.addLimit && vm.bubbleCount <= 0) || index || index === 0) {
        if (!(this.$store.getters.getPackage == 'normal' && this.isBroadCast)) {
          let input = {
            detail: '',
            value: 0,
            // delivery: { name: '', code: 0 },
            text: 'จ่ายบิลได้ที่',
            type: 'pay_solutions_link',
            create: true
          }
          vm.modalPaysolution = item ? { ...item.data, index, create: false } : input
          vm.paysolutionDialog = true
        }
      }
    },
    updatePaymentItem(obj) {
      Object.assign(this.bubbleMessages[obj.index], {
        data: obj,
        text: `{sendgbprimelink(${obj.detail}&&${obj.amount}&&${obj.delivery.code}&&${obj.response})}`
      })
    },
    updatePaysolutionItem(obj) {
      Object.assign(this.bubbleMessages[obj.index], { data: obj })
    },
    updateMetaPaymentItem(obj) {
      const vm = this
      vm.bubbleMessages[obj.index] = obj
    },
    closeModal() {
      this.dialog = {
        addPayment: false,
        editPayment: false
      }
    },
    cancelAddFlexMessage: function() {
      this.showLineFlex = false
      this.resetFlexMessage()
    },
    saveAddFlexMessage: function() {
      var vm = this
      if (vm.flexMessage.altText === '') {
        vm.flexMessage.altText = 'You received a message'
      }
      vm.bubbleMessages.push(vm.flexMessage)
      vm.$emit('input', vm.bubbleMessages)
      vm.showLineFlex = false
      vm.resetFlexMessage()
    },
    resetFlexMessage: function() {
      this.flexMessage = {
        type: 'flex',
        altText: 'You received a message',
        contents: '{}'
      }
    },
    addVideo: function(video) {
      const vm = this
      vm.bubbleMessages.push(video)
      vm.$emit('input', vm.bubbleMessages)
      vm.showVideo = false
    },
    addIntentItem: function(type, data) {
      const vm = this
      if (vm.bubbleCount >= vm.addLimit || vm.hasAloneIntent) {
        return false
      }
      // summary_service
      if (type == 'summary_service') {
        vm.bubbleMessages.push({
          text: `เลขที่ทำรายการ {{order_no}}
รายละเอียดเข้ารับบริการ : {{order_detail}}`,
          type: 'text',
          custom_type: 'summary_service'
        })
      } else if (type == 'text') {
        vm.bubbleMessages.push({
          text: '',
          type: type
        })
      } else if (
        type == 'button' &&
        !(vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
      ) {
        vm.bubbleMessages.push({
          text: '',
          buttons: [],
          type: type
        })
      } else if (type == 'image' && !(vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)) {
        vm.bubbleMessages.push({
          image_url: '',
          type: type
        })
      } else if (
        type == 'meta_pay' &&
        !(vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
      ) {
        vm.bubbleMessages.push({
          type: type,
          detail: data.detail,
          amount: data.amount,
          note: data.note,
          is_create_order: data.is_create_order
        })
      } else if (
        type == 'payment' &&
        !(vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
      ) {
        vm.bubbleMessages.push({
          text: `{sendgbprimelink(${data.detail}&&${data.amount}&&${data.delivery.code}&&${data.response})}`,
          data: data,
          type: type
        })
      } else if (
        type == 'pay_solutions_link' &&
        !(vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
      ) {
        vm.bubbleMessages.push({
          // text: `{sendgbprimelink(${data.detail}&&${data.amount}&&${data.delivery.code}&&${data.response})}`,
          data: data,
          type: type
        })
      } else if (
        ['removeandaddtocart', 'addtocart', 'removetocart'].includes(type) &&
        !(vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
      ) {
        var { obj, checkstock, checksameproductincarts, adjuststock } = data
        var mytext = obj.map(el => `{"pid":${el.pid},"qty":${el.qty},"option":"${el.option}"}`)
        vm.bubbleMessages.push({
          text: `{${type}([${mytext}])}`,
          data: obj,
          type: type,
          checkstock: checkstock,
          checksameproductincarts: checksameproductincarts,
          adjuststock: adjuststock
        })
      } else if (
        (type == 'generic' || type == 'catalogue') &&
        !(vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
      ) {
        vm.bubbleMessages.push({
          data: [
            {
              image_url: null,
              title: '',
              subtitle: '',
              buttons: []
            }
          ],
          altText: 'You received a message',
          type: type === 'catalogue' ? 'generic' : type,
          custom_type: type === 'catalogue' ? 'catalogue' : null
        })
      } else if (
        type == 'welcome_message' &&
        vm.intentname != '{welcome}' &&
        !(vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
      ) {
        vm.bubbleMessages.push({
          type: type
        })
      } else if (
        type == 'viewsummary' &&
        !(vm.$store.getters.getPackage == 'normal' && vm.isBroadCast)
      ) {
        if (vm.products.length == 0) {
          return false
        }
        vm.bubbleMessages.push({
          type: 'text',
          text: '{viewsummary}'
        })
      } else if (
        type == 'video' &&
        !(vm.$store.getters.getPackage == 'normal' && vm.isBroadCast) &&
        vm.channel != 'google'
      ) {
        vm.showVideo = true
      } else if (
        type == 'line_flex' &&
        vm.$store.getters.getPackage == 'premium' &&
        !vm.isCoachlab &&
        !['facebook', 'google'].includes(vm.channel)
      ) {
        vm.showLineFlex = true
      } else if (
        type == 'line_imagemap' &&
        vm.getPackageType().includes('advanced') &&
        !['facebook', 'google'].includes(vm.channel)
      ) {
        vm.showLineImageMap = true
      } else if (
        type == 'line_sticker' &&
        !['facebook', 'google'].includes(vm.channel) &&
        vm.$store.getters.getPackage == 'premium'
      ) {
        vm.showLineSticker = true
      } else if (type == 'ntn_template' && !['google', 'line'].includes(vm.channel)) {
        vm.bubbleMessages.push({
          image_url: null,
          title: '',
          notification_messages_frequency: '',
          type: 'ntn_template'
        })
      }
      vm.$emit('input', vm.bubbleMessages)
      vm.checkCountNtn()
    },
    async onDelete(index) {
      const vm = this
      // if (
      //   vm.bubbleMessages[index] &&
      //   vm.bubbleMessages[index].text
      //   // vm.bubbleMessages[index].text.includes('สถานะ: {verify_slip.result}')
      // ) {
      //   const result = await vm.$swal.fire({
      //     title: vm.$t('delete_payment_method'),
      //     type: 'question',
      //     showCancelButton: true,
      //     confirmButtonText: vm.$t('Confirm'),
      //     cancelButtonText: vm.$t('cancel'),
      //     reverseButtons: true
      //   })
      //   // if (result.value) {
      //   //   vm.bubbleMessages.splice(index, 1)
      //   //   vm.$emit('input', vm.bubbleMessages)
      //   //   vm.$emit('clearToWayVerify')
      //   //   vm.checkCountNtn()
      //   // }
      // } else {
      vm.bubbleMessages.splice(index, 1)
      vm.$emit('input', vm.bubbleMessages)
      vm.checkCountNtn()
      // }
    },
    checkCountNtn() {
      const vm = this
      if (vm.messagesType === 'NTN_BROADCAST' && vm.bubbleMessages.length >= 1) {
        vm.remarkNtn = true
      } else {
        vm.remarkNtn = false
      }
    },
    onMove: function(index, direction) {
      var vm = this
      if (direction == 'up') {
        vm.bubbleMessages.splice(index, 0, vm.bubbleMessages.splice(index - 1, 1)[0])
      } else if (direction == 'down') {
        vm.bubbleMessages.splice(index, 0, vm.bubbleMessages.splice(index + 1, 1)[0])
      }
      vm.$emit('input', vm.bubbleMessages)
    },
    onMoveButton: function(index, direction, item) {
      var vm = this

      if (direction == 'up') {
        item.buttons.splice(index, 0, item.buttons.splice(index - 1, 1)[0])
      } else if (direction == 'down') {
        item.buttons.splice(index, 0, item.buttons.splice(index + 1, 1)[0])
      }

      vm.$emit('input', vm.bubbleMessages)
    },
    addNewButton: function(index, payload) {
      if (this.bubbleMessages[index].buttons.length < 3) {
        if (payload.type == 'web_url') {
          delete payload.payload
        } else if (payload.type == 'postback' || payload.type == 'phone_number') {
          delete payload.url
        }
        this.bubbleMessages[index].buttons.push(payload)
        this.newButton = {
          title: '',
          type: 'web_url',
          url: ''
        }
        this.$emit('input', this.bubbleMessages)
      }
      this.saveTimestamp = dayjs().format('x')
    },
    editButton: function(index, bindex, payload) {
      if (this.bubbleMessages[index].buttons[bindex]) {
        // this.intentItems[index].value.buttons[index] = payload
        if (payload.type == 'web_url') {
          delete payload.payload
        } else if (payload.type == 'postback' || payload.type == 'phone_number') {
          delete payload.url
        }
        this.$set(this.bubbleMessages[index].buttons, bindex, payload)
        this.$emit('input', this.bubbleMessages)
      }
      this.editTimestamp = dayjs().format('x')
    },
    deleteButton: function(index, bindex) {
      this.bubbleMessages[index].buttons.splice(bindex, 1)
      this.$emit('input', this.bubbleMessages)
    },
    addIntentPrefillGroup: function(index, subindex, prefill) {
      const vm = this
      vm.addIntentPrefill(index, subindex, prefill, true)
    },
    addIntentPrefill: function(index, subindex, prefill, isGroup) {
      const vm = this
      let cursorPosition = this.$refs['answer_' + index + '_' + subindex][0].$el.selectionStart

      if (vm.bubbleMessages[subindex].type === 'text') {
        vm.$set(
          vm.bubbleMessages[subindex],
          'text',
          [
            vm.bubbleMessages[subindex].text.slice(0, cursorPosition),
            isGroup ? prefill : '{' + prefill + '}',
            vm.bubbleMessages[subindex].text.slice(cursorPosition)
          ].join('')
        )
      } else if (vm.bubbleMessages[subindex].type == 'button') {
        vm.$set(
          vm.bubbleMessages[subindex],
          'text',
          [
            vm.bubbleMessages[subindex].text.slice(0, cursorPosition),
            isGroup ? prefill : '{' + prefill + '}',
            vm.bubbleMessages[subindex].text.slice(cursorPosition)
          ].join('')
        )
      }
      this.$emit('input', this.bubbleMessages)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/intent/IntentGroupItem.js